var map = {
	"./icon1.png": "0674",
	"./icon2.png": "816f",
	"./icon3.png": "62eb",
	"./icon4.png": "bff0",
	"./icon5.png": "3b02",
	"./icon6.png": "553c",
	"./icon7.png": "3323",
	"./icon8.png": "bc7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd02";